import * as React from 'react';

import { AppRoutes } from 'constants/routes';

import ArrowLeft from 'assets/icons/arrows/arrow-left-16.svg';

import ContentPlaceholder from 'basics/loaders/ContentPlaceholder/ContentPlaceholder';
import { Bar, SkeletonStack } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

import { PageContainer } from 'styles/commonPageStyles';
import {
    Form,
    FormBackButton,
    FormPageContentWrap,
    FormPageHeaderTitle,
    FormPageHeaderWrap,
    FormSection,
    FormSectionTitle,
    FormWrap,
} from 'styles/sharedFormPage.styled';

import { Options } from './CreatePoolLoading.styled';

const CreatePoolLoading = () => (
    <PageContainer>
        <FormPageHeaderWrap>
            <FormPageContentWrap>
                <FormBackButton label="Pools" to={AppRoutes.section.amm.link.index}>
                    <ArrowLeft />
                </FormBackButton>
                <FormPageHeaderTitle>Create Pool</FormPageHeaderTitle>
            </FormPageContentWrap>
        </FormPageHeaderWrap>
        <FormWrap>
            <FormPageContentWrap>
                <Form as="div">
                    <FormSection>
                        <FormSectionTitle>Select pool type</FormSectionTitle>
                        <ContentPlaceholder label="Loading pool creation">
                            <Options $gap="1.6rem">
                                {[0, 1, 2].map(i => (
                                    <Bar key={i} $width="100%" $height="12rem" />
                                ))}
                            </Options>
                        </ContentPlaceholder>
                    </FormSection>
                    <FormSection>
                        <FormSectionTitle>Select tokens for pool</FormSectionTitle>
                        <SkeletonStack>
                            <Bar $width="100%" $height="8rem" />
                            <Bar $width="100%" $height="8rem" />
                        </SkeletonStack>
                    </FormSection>
                </Form>
            </FormPageContentWrap>
        </FormWrap>
    </PageContainer>
);

export default CreatePoolLoading;
